import { MessagingBlock } from '@strata/react-messaging-block';

import Closed from 'assets/closed.svg?react';
import Opening from 'assets/opening.svg?react';
import { formatHour } from 'components/liveReferrals/offHoursScreens/ObservedHolidays';
import { type LiveReferralHours, useGetLiveReferralHoursQuery } from 'store/api/auctionApi';

const Types = {
    OPENING: 'OPENING',
    CLOSED: 'CLOSED',
    WEEKEND: 'WEEKEND',
};
type Type = (typeof Types)[keyof typeof Types];

const IconMap = {
    [Types.OPENING]: Opening,
    [Types.CLOSED]: Closed,
    [Types.WEEKEND]: Closed,
};

const PrimaryTextMap = {
    [Types.OPENING]: 'Rise and shine!',
    [Types.CLOSED]: "We've called it a day. Thank you for stopping by.",
    [Types.WEEKEND]: 'Live Referrals are not available.',
};

const getSecondaryText = (type: Type, hours?: LiveReferralHours) => {
    if (hours) {
        if (type === Types.OPENING) {
            return `Live Referrals will be available at ${formatHour(hours.start)}.`;
        }

        return `Live Referrals are active Monday through Friday from ${formatHour(
            hours.start,
        )} to ${formatHour(hours.end)}.`;
    }

    return undefined;
};

interface OffHoursScreenProps {
    type: Type;
}

export const OffHoursScreen = ({ type }: OffHoursScreenProps) => {
    const { data } = useGetLiveReferralHoursQuery();
    const OffHoursIcon = IconMap[type];

    return (
        <div className="sds_fullscreen-page">
            <MessagingBlock
                className="sds_fullscreen-page__message-container"
                size={MessagingBlock.Sizes.LARGE}
                icon={<OffHoursIcon />}
                primaryText={PrimaryTextMap[type]}
                secondaryText={getSecondaryText(type, data)}
            />
        </div>
    );
};

OffHoursScreen.Types = Types;
